import {useEffect, useRef, useState} from 'react';
import Video from 'twilio-video';

import {
    Button,
    Card,
    Col,
    Divider,
    FloatButton,
    Form,
    message,
    Modal,
    Popover,
    Row,
    Space,
    Spin,
    Statistic,
    Tooltip,
    Typography
} from "antd";
import RemoteParticipantView from "./RemoteParticipantView";
import {ParticipantStatus} from "../../../enums/ParticipantStatus";
import {VideoStatus} from "../../../enums/VideoStatus";
import TakePhotoButton from "../common/TakePhotoButton";
import {
    CameraTwoTone,
    CheckCircleOutlined,
    CloseCircleOutlined,
    CloseOutlined,
    ExclamationCircleOutlined,
    LoadingOutlined,
    StopOutlined
} from "@ant-design/icons";
import './style.scss'
import LocalParticipantView from "./LocalParticipantView";
import DocumentView, {DocumentViewRef} from "./documentview";
import jobApiService from "../../../service/jobApiService";
import RecordVideoButton from "../common/RecordVideoButton";
import CallLeaveButton from "../common/CallLeaveButton";

import GoogleMapView from "../common/GoogleMapView";
import {FileProperty} from "../../common/documentviewer/FileProperty";
import documentService from "../../../service/documentService";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faMicrophone, faMicrophoneSlash} from "@fortawesome/free-solid-svg-icons";
import {
    ADMIN_VERIFICATION_TYPE,
    BASKET_STATUS_SIGNATURE_BASKET,
    CUSTOMER_VERIFICATION_STATUS,
    DOC_CODE_SIGNATURE_DOC
} from "../../../util/Constants";
import modal from "antd/es/modal";
import {AdminRequestDto} from "../../../dto/admin/AdminRequestDto";
import adminService from "../../../service/adminService";
import ErrorHandler from "../../../util/ErrorHandler";
import TextArea from "antd/es/input/TextArea";
import {useHistory} from "react-router-dom";
import dayjs from "dayjs";
import {CalendarOutlined, ClockCircleOutlined} from '@ant-design/icons/lib';
import {SignatureDto} from "../../../dto/SignatureDto";
import customerChangeRequestAdminService from "../../../service/customerChangeRequestAdminService";
import {useKeycloak} from "@react-keycloak/web";
import {StompSessionProvider} from "react-stomp-hooks";


const {Link, Paragraph} = Typography;


const spinIcon = <LoadingOutlined style={{fontSize: 24}} spin/>;
const baseUrl: string | undefined = process.env.BASE_API_URL ? process.env.BASE_API_URL : "";
export default function LocalRoomComp({
                                          jobNumber,
                                          identityDocumentTypeCode,
                                          roomName,
                                          token,
                                          handleLogout,
                                          setVideoStatusProgress,
                                          setParticipantConnectingStatus,
                                          addDocumentWindow,
                                          username,
                                          participantConnectingStatus,
                                          callLink,
                                          workId,
                                          scheduledDateTime,
                                          basketStatus,
                                          cin,
                                      }: {
    jobNumber: number,
    identityDocumentTypeCode: string,
    roomName: string,
    token: string,
    handleLogout: any,
    setVideoStatusProgress(status: VideoStatus): void,
    setParticipantConnectingStatus(participantStatus: ParticipantStatus): void,
    addDocumentWindow(fileProperty: FileProperty, contentType: string): void,
    username: string,
    participantConnectingStatus: ParticipantStatus,
    callLink: string,
    workId: number,
    scheduledDateTime: string,
    basketStatus: string,
    cin: string,
}) {
    const [room, setRoom] = useState<Video.Room>();
    const [participants, setParticipants] = useState<Array<Video.RemoteParticipant>>([]);
    const [capturedDocumentTypeList, setCapturedDocumentTypeList] = useState<Array<any>>([]);
    const [connectionStatus, setConnectionStatus] = useState<VideoStatus>(VideoStatus.OFFLINE);
    const [mute, setMute] = useState<boolean>(false);
    const [isRemarkModalOpen, setRemarkModalOpen] = useState<boolean>(false);
    const [isLoadingOnSubmit, setLoadingOnSubmit] = useState<boolean>(false);
    const [documentViewKey, setDocumentViewKey] = useState(0);
    const [isAddedLoaderOnPictureTaking, setLoaderOnPictureTaking] = useState<boolean>(false);
    const [isCanShowRecording, setCanShowRecording] = useState<boolean>(true);
    let history = useHistory();
    let [rejectForm] = Form.useForm();
    const {keycloak} = useKeycloak();
    const [open, setOpen] = useState(false);
    const documentViewRef = useRef<DocumentViewRef>(null);
    const hide = () => {
        setOpen(false);
    };

    const handleOpenChange = (newOpen: boolean) => {
        setOpen(newOpen);
    };


    const tidyUp = (room: Video.Room) => {
        return function (event: any) {
            if (event.persisted) {
                return;
            }
            if (room) {
                room.disconnect();
            }
        };
    }

    useEffect(() => {
        if (basketStatus === BASKET_STATUS_SIGNATURE_BASKET) {
            documentService.getDocumentTypeList(true, identityDocumentTypeCode).then(res => {
                if (res.data.status == 'SUCCESS') {
                    if (res.data.results !== null) {
                        //retrieve only signature capture button
                        let signatureCaptureButton = res.data.results.filter((obj) => obj.documentTypeCode === DOC_CODE_SIGNATURE_DOC)
                        if (signatureCaptureButton != null) {
                            setCapturedDocumentTypeList(signatureCaptureButton);
                        }
                    }

                }
            }, reason => {
                console.log("Service not available")
            });

        } else {
            documentService.getDocumentTypeListByJobNo(true, identityDocumentTypeCode, jobNumber).then(res => {
                if (res.data.status == 'SUCCESS') {
                    if (res.data.results !== null) {
                        setCapturedDocumentTypeList(res.data.results);
                    }

                }
            }, reason => {
                console.log("Service not available")
            });
        }
        return () => {
            setCapturedDocumentTypeList([]);
        };
    }, []);

    const roomRef = useRef<Video.Room | undefined>(undefined);

    useEffect(() => {
        const participantConnected = async (participant: Video.RemoteParticipant) => {
            let participants: Array<Video.RemoteParticipant> = [];
            await jobApiService.updateRemoteParticipantDetail(participant.sid, participant.identity);
            participants.push(participant);
            setParticipants(participants);
            setParticipantConnectingStatus(ParticipantStatus.PARTICIPANT_CONNECTED);
            setVideoStatusProgress(VideoStatus.ONLINE);
        };

        const participantDisconnected = (participant: Video.RemoteParticipant) => {
            setParticipants([]);
            setParticipantConnectingStatus(ParticipantStatus.PARTICIPANT_DISCONNECTED);
        };

        const participantReconnecting = (participant: Video.RemoteParticipant) => {
            setParticipantConnectingStatus(ParticipantStatus.RECONNECTING);
            setVideoStatusProgress(VideoStatus.CONNECTING);

        };

        const reconnected = () => {
            setParticipantConnectingStatus(ParticipantStatus.PARTICIPANT_RECONNECTED);
            setVideoStatusProgress(VideoStatus.ONLINE);

        };


        Video.connect(token, {
            name: roomName,
            audio: true,
            maxAudioBitrate: 16000,
            video: true,
        }).then(async (room: Video.Room) => {
            setVideoStatusProgress(VideoStatus.CONNECTING);
            setRoom(room);
            //using ref to disconnect the room when the component unmount
            roomRef.current = room;
            await jobApiService.updateRoomDetails(room.sid, room.localParticipant.sid, room.name);

            room.on('participantConnected', participantConnected);
            room.on('participantDisconnected', participantDisconnected);
            room.on('participantReconnecting', participantReconnecting);
            room.on('reconnected', reconnected);
            window.addEventListener("beforeunload", tidyUp(room));
            window.addEventListener("pagehide", tidyUp(room));
            room.participants.forEach(participantConnected);
            setConnectionStatus(VideoStatus.CONNECTED);
            setVideoStatusProgress(VideoStatus.ONLINE);
        }, (error) => {
            if (error.name === 'NotAllowedError') {
                message.error('Camera and microphone permissions were denied. ' +
                    'Please allow permissions in your browser settings.');
            } else {
                message.error('An error occurred while requesting camera and microphone permissions.');
            }
        });


        return () => {
            const currentRoom = roomRef.current;
            disconnectRoom(currentRoom)
            handleLogout();
        };
    }, [roomName, token]);


    const remoteParticipants = participants.map((participant) => {
        // console.log("Remote Participant details ", participants.length)
        if (username !== participant.identity) {
            return (<RemoteParticipantView key={participant.sid} participant={participant}
                                           setVideoStatusProgress={setVideoStatusProgress}/>)
        }
        return <></>

    });

    const onMuteMicrophone = (e: any) => {

        room?.localParticipant.audioTracks.forEach(publication => {
            if (mute) {
                publication.track.enable();
                setMute(prevState => !prevState)
            } else {
                publication.track.disable();
                setMute(prevState => !prevState);
            }

        })
    }

    const handleButtonClick = () => {
        if (documentViewRef.current) {
            return documentViewRef.current.getCanVerify().canVerify
        } else {
            return false;
        }
    };

    const verifyOrReject = (type: CUSTOMER_VERIFICATION_STATUS) => {
        if (type === CUSTOMER_VERIFICATION_STATUS.VERIFIED && !handleButtonClick()) {
            message.warning("Kindly ensure all required documents are captured before proceeding with verification!")
            return;
        }
        setLoadingOnSubmit(true)
        if (basketStatus === BASKET_STATUS_SIGNATURE_BASKET) {
            modal.confirm({
                title: 'Confirm',
                icon: <ExclamationCircleOutlined/>,
                content: `Are you sure you want to ${type === CUSTOMER_VERIFICATION_STATUS.REJECTED ?
                    "reject" : "verify"} the job?`,
                okText: 'Yes',
                cancelText: 'No',
                className: 'confirm-dialog-box',
                okButtonProps: {style: {background: '#FF7400'}},
                onOk() {
                    if (type === CUSTOMER_VERIFICATION_STATUS.REJECTED) {
                        setLoadingOnSubmit(false)
                        setRemarkModalOpen(true)
                    } else {
                        let signatureChangeRequestDto = {} as SignatureDto;
                        signatureChangeRequestDto.jobNumber = jobNumber
                        signatureChangeRequestDto.cin = cin
                        signatureChangeRequestDto.recordStatus = "ACCEPTED"
                        signatureChangeRequestDto.rejectReason = ""
                        customerChangeRequestAdminService.acceptOrRejectSignatureChangeRequest(signatureChangeRequestDto, cin).then((res) => {
                            message.success(
                                `Task verified successfully`).then(localStorage.removeItem('workBasketData'))
                            history.push('/workflow/localvideolist')
                            setLoadingOnSubmit(false)
                        }).catch(reason => {
                            ErrorHandler.handleError(reason)
                            setLoadingOnSubmit(false)
                        })
                    }

                },
                onCancel() {
                    setLoadingOnSubmit(false)
                }
            });
        } else {
            modal.confirm({
                title: 'Confirm',
                icon: <ExclamationCircleOutlined/>,
                content: `Are you sure you want to ${type === CUSTOMER_VERIFICATION_STATUS.REJECTED ?
                    "reject" : type === CUSTOMER_VERIFICATION_STATUS.DECLINED ? "decline" : "verify"} the job?`,
                okText: 'Yes',
                cancelText: 'No',
                className: 'confirm-dialog-box',
                okButtonProps: {style: {background: '#FF7400'}},
                onOk() {
                    if (type === CUSTOMER_VERIFICATION_STATUS.REJECTED) {
                        setLoadingOnSubmit(false)
                        setRemarkModalOpen(true)
                    } else {
                        let adminRequestDto = {} as AdminRequestDto;
                        adminRequestDto.adminWorkType = ADMIN_VERIFICATION_TYPE.CUSTOMER_VIDEO_VERIFICATION
                        adminRequestDto.workId = workId
                        adminRequestDto.customerVerificationStatus = type
                        adminRequestDto.rejectReason = ""
                        adminService.verifyVideo(adminRequestDto).then((res) => {
                            message.success(
                                `Task ${type === CUSTOMER_VERIFICATION_STATUS.DECLINED ? "declined" : "verified"} successfully`).then(localStorage.removeItem('workBasketData'))
                            history.push('/workflow/localvideolist')
                            setLoadingOnSubmit(false)
                        }).catch(reason => {
                            ErrorHandler.handleError(reason)
                            setLoadingOnSubmit(false)
                        })
                    }

                },
                onCancel() {
                    setLoadingOnSubmit(false)
                }
            });
        }

    }
    const handleCancel = () => {
        setRemarkModalOpen(false)
    }
    const submitReject = (value: { rejectReason: string | undefined, internalRemark: string | undefined }) => {
        setRemarkModalOpen(false)
        setLoadingOnSubmit(true)
        if (basketStatus === BASKET_STATUS_SIGNATURE_BASKET) {
            let signatureChangeRequestDto = {} as SignatureDto;
            signatureChangeRequestDto.jobNumber = jobNumber
            signatureChangeRequestDto.cin = cin
            signatureChangeRequestDto.recordStatus = "REJECTED"
            signatureChangeRequestDto.rejectReason = value.rejectReason ? value.rejectReason : ""
            customerChangeRequestAdminService.acceptOrRejectSignatureChangeRequest(signatureChangeRequestDto, cin).then((res) => {
                message.success(
                    `Task rejected successfully`).then(localStorage.removeItem('workBasketData'))
                history.push('/workflow/localvideolist')
                setLoadingOnSubmit(false)
            }).catch(reason => {
                ErrorHandler.handleError(reason)
                setLoadingOnSubmit(false)
            })
        } else {
            let adminRequestDto = {} as AdminRequestDto;
            adminRequestDto.adminWorkType = ADMIN_VERIFICATION_TYPE.CUSTOMER_VIDEO_VERIFICATION
            adminRequestDto.workId = workId
            adminRequestDto.customerVerificationStatus = CUSTOMER_VERIFICATION_STATUS.REJECTED
            adminRequestDto.rejectReason = value.rejectReason
            adminRequestDto.internalRemark = value.internalRemark
            adminService.verifyVideo(adminRequestDto).then((res) => {
                message.success(`Task rejected successfully`).then(localStorage.removeItem('workBasketData'))
                history.push('/workflow/localvideolist')
                setLoadingOnSubmit(false)
            }).catch(reason => {
                setRemarkModalOpen(true)
                ErrorHandler.handleError(reason)
                setLoadingOnSubmit(false)
            })
        }

    }
    const handleCallLeave = () => {
        setRoom((currentRoom) => {
            return disconnectRoom(currentRoom)
        });
        handleLogout()
    }

    const disconnectRoom = (currentRoom: Video.Room | undefined) => {
        if (currentRoom && currentRoom.localParticipant.state === 'connected') {
            currentRoom.localParticipant.tracks.forEach(function (trackPublication) {
                // console.log(trackPublication)
                if (trackPublication.track instanceof Video.LocalAudioTrack) {
                    trackPublication.track.stop();
                } else if (trackPublication?.track instanceof Video.LocalVideoTrack) {
                    trackPublication.track.stop();
                }

            });
            currentRoom.disconnect();
            setVideoStatusProgress(VideoStatus.ROOM_DISCONNECTED);
            setConnectionStatus(VideoStatus.ROOM_DISCONNECTED);
            return;
        } else {
            return currentRoom;
        }
    }
    const handleCallLeaveBtn = () => {
        handleCallLeave()
        handleLogout()
        history.push('/workflow/localvideolist')
    }
    const addLoaderOnPictureCapturing = () => {
        setLoaderOnPictureTaking(true)
    }
    const uploadingStatus = (value: boolean) => {
        if (!value) {
            setTimeout(() => {
                setLoaderOnPictureTaking(value)
                setCanShowRecording(false)
            }, 2500)
        } else {
            setLoaderOnPictureTaking(value)
        }

    }
    const buttonSize = basketStatus === BASKET_STATUS_SIGNATURE_BASKET ? 12 : 8
    return (
        <StompSessionProvider
            connectHeaders={{
                accessToken: keycloak.token ? keycloak.token : "",
                username: username,
            }}
            url={`${baseUrl}/video/socket`}
            onWebSocketClose={(evt) => {
                console.log('WebSocket closed: ', evt);
            }}
        >
            <div className='local-video-room'>
                <Spin spinning={isLoadingOnSubmit}>
                    <Row gutter={24} className=''>
                        <Col lg={8} sm={24} xs={24}>
                            <Card title='Documents' className='already-document-card-height' size={'small'}>
                                <Row gutter={16}>
                                    <Col sm={24} xs={24}>
                                        <DocumentView
                                            ref={documentViewRef}
                                            jobNo={jobNumber}
                                            identityDocumentTypeCode={identityDocumentTypeCode}
                                            addDocumentWindow={addDocumentWindow}
                                            capturedDoc={false}
                                            key={documentViewKey}
                                            basketStatus={basketStatus}
                                            uploadingStatus={uploadingStatus}
                                        />
                                    </Col>

                                </Row>
                            </Card>
                        </Col>
                        {
                            participantConnectingStatus == ParticipantStatus.PARTICIPANT_CONNECTED ?
                                <>

                                    <Col lg={9}>
                                        <Row className='canvas-row'>
                                            <Col lg={24}>
                                                <Card style={{borderRadius: 32}} size={'small'}
                                                      className='video-canvas-card_local'>
                                                    <div className="video-render">
                                                        {remoteParticipants}
                                                        {isCanShowRecording && (
                                                            <div className="recording-started"></div>
                                                        )}
                                                    </div>
                                                </Card>
                                            </Col>
                                            <Col span={24} className='button_group_col_local'>
                                                <div className='call-btn-group_local'>
                                                    <RecordVideoButton
                                                        participantConnectingStatus={participantConnectingStatus}
                                                        username={username}
                                                        canShowRecording={(value: boolean) => setCanShowRecording(value)}/>

                                                    <GoogleMapView
                                                        participantConnectingStatus={participantConnectingStatus}
                                                        username={username}/>
                                                    <Tooltip title={mute ? "Unmute" : "Mute"}>
                                                        <Button type="primary"
                                                                style={{backgroundColor: mute ? '#e0dede' : '#1e59b6'}}
                                                                shape="circle"
                                                                className={mute ? 'unmute-btn' : 'mute-btn'}
                                                                icon={mute ?
                                                                    <FontAwesomeIcon icon={faMicrophoneSlash}/> :
                                                                    <FontAwesomeIcon icon={faMicrophone}/>}
                                                                onClick={onMuteMicrophone} size={"large"}/>
                                                    </Tooltip>
                                                    {
                                                        connectionStatus === VideoStatus.CONNECTED &&

                                                        <CallLeaveButton
                                                            participantConnectingStatus={participantConnectingStatus}
                                                            username={username} handleLogout={handleCallLeaveBtn}/>

                                                    }
                                                </div>
                                            </Col>

                                        </Row>

                                    </Col>
                                </>
                                : <Col className='admin_not_join_div' lg={9}>
                                    <div>
                                        <Spin indicator={spinIcon} size={"large"}/>
                                        <h3>Participant Will Join</h3>
                                        <h3>Please Wait</h3>
                                    </div>
                                </Col>
                        }

                        <Col lg={7}>
                            <Card title='Meeting Details' className='already-document-card' size={'small'}
                                  actions={[

                                      <Row gutter={8} className='meeting-details-btn-row'>
                                          {
                                              basketStatus !== BASKET_STATUS_SIGNATURE_BASKET ?
                                                  <Col sm={8} md={8} lg={8} xl={8} className='video_buttons btn-col-1'>
                                                      <Button
                                                          onClick={() => verifyOrReject(CUSTOMER_VERIFICATION_STATUS.DECLINED)}
                                                          round type="primary" danger
                                                          disabled={isCanShowRecording}
                                                          className={'decline_btn_color'}
                                                          icon={<CloseCircleOutlined/>}>Decline</Button>
                                                  </Col> : ''
                                          }

                                          <Col sm={buttonSize} md={buttonSize} lg={buttonSize} xl={buttonSize}
                                               className='video_buttons  btn-col-2'>
                                              <Button
                                                  onClick={() => verifyOrReject(CUSTOMER_VERIFICATION_STATUS.REJECTED)}
                                                  disabled={isCanShowRecording}
                                                  round type="primary" className={'reject_btn_color'}
                                                  icon={<StopOutlined/>}>Reject</Button>
                                          </Col>
                                          <Col sm={buttonSize} md={buttonSize} lg={buttonSize} xl={buttonSize}
                                               className='video_buttons btn-col-3'>
                                              <Button
                                                  disabled={isCanShowRecording}
                                                  onClick={() => verifyOrReject(CUSTOMER_VERIFICATION_STATUS.VERIFIED)}
                                                  round icon={<CheckCircleOutlined/>}
                                                  className={'verify_btn_color'}
                                              >Verify</Button>
                                          </Col>
                                      </Row>

                                  ]}

                                  extra={
                                      <>
                                          <Space>
                                              {/*<Button type='link'>Join Meeting</Button>*/}
                                              <Link href={callLink} target="_blank">
                                                  <Paragraph style={{margin: 0}} copyable={{text: '' + callLink}}>Meeting
                                                      Link</Paragraph>
                                              </Link>
                                          </Space>
                                      </>

                                  }>
                                <Row>
                                    <Col span={24}>
                                        <div className="meeting-sch-date-time-info">
                                            <div className="sch-date-info">
                                                <Statistic title="Date"
                                                           value={dayjs(scheduledDateTime).format("dddd, MMM DD")}
                                                           prefix={<CalendarOutlined/>}/>
                                            </div>
                                            <div className="sch-time-info">
                                                <Statistic title="Time"
                                                           value={dayjs(scheduledDateTime).format("hh:mm A")}
                                                           prefix={<ClockCircleOutlined/>}/>
                                            </div>
                                        </div>

                                    </Col>
                                    <Divider orientation="left" className='meeting-info-divider'
                                             orientationMargin="0">Capture</Divider>
                                    <Col sm={24}>
                                        <div>
                                            {
                                                capturedDocumentTypeList.map(dto => <TakePhotoButton
                                                    imageType={dto.documentTypeCode} documentTypeId={dto.documentTypeId}
                                                    buttonName={dto.labelName}
                                                    btnQuestion={dto.captureInfo}
                                                    participantConnectingStatus={participantConnectingStatus}
                                                    username={username}
                                                    jobNumber={jobNumber}
                                                    onTakePictureSuccess={() => {
                                                        setDocumentViewKey(prevKey => prevKey + 1)
                                                        setLoaderOnPictureTaking(false)
                                                    }

                                                    }
                                                    onTakingPictureAddLoader={addLoaderOnPictureCapturing}
                                                    disableCaptureBtn={isAddedLoaderOnPictureTaking}
                                                />)
                                            }
                                        </div>


                                        {/*<Descriptions column={1}>*/}
                                        {/*<Descriptions.Item label="Meeting Link">*/}
                                        {/*    <Link href={callLink} target="_blank">*/}
                                        {/*        <Paragraph copyable={{ text: '' + callLink }}></Paragraph>*/}
                                        {/*    </Link>*/}
                                        {/*</Descriptions.Item>*/}
                                        {/*<Descriptions.Item label="Room ID"> {roomName}</Descriptions.Item>*/}
                                        {/*</Descriptions>*/}


                                    </Col>
                                </Row>
                            </Card>
                        </Col>

                        <Popover
                            open={open}
                            onOpenChange={handleOpenChange}
                            content={
                                <>
                                    {room ? (
                                        <LocalParticipantView
                                            key={room.localParticipant.sid}
                                            participant={room.localParticipant}
                                        />
                                    ) : (
                                        ''
                                    )}
                                </>
                            }
                            title={<div className={"popover_close_btn"}>My Cam <span> <Button onClick={hide}
                                                                                              type="text"><CloseOutlined/>

    </Button></span></div>}
                            trigger="click"

                        >
                            <FloatButton icon={<CameraTwoTone/>} onClick={() => console.log('click')}/>
                        </Popover>
                    </Row>
                </Spin>

                <Modal destroyOnClose={true}
                       maskClosable={false}
                       title="Reject Reason / Internal Remark"
                       open={isRemarkModalOpen}
                       footer={[]}
                       onCancel={handleCancel}
                >

                    <Form
                        className='form-input attachments-upload-form'
                        layout={"vertical"}
                        form={rejectForm}
                        onFinish={submitReject}
                        preserve={false}
                    >
                        <Form.Item
                            name={"rejectReason"}
                            label={<b>Reject Reason</b>}
                            rules={[{
                                required: true,
                                message: 'Please enter reject reason'
                            }]}>
                            <TextArea showCount placeholder="Please enter reject reason" maxLength={255}
                                      bordered={true}/>
                        </Form.Item>
                        {
                            basketStatus !== BASKET_STATUS_SIGNATURE_BASKET ?
                                <Form.Item
                                    name={"internalRemark"}
                                    label={<b>Internal Remark</b>}>
                                    <TextArea showCount placeholder="Please enter internal remark" maxLength={255}
                                              bordered={true}/>
                                </Form.Item> : ''
                        }

                        <Form.Item>
                            <Space style={{float: 'right'}}>
                                <Button htmlType="submit" type="success"
                                        style={{background: "#FF7400", color: "white", marginTop: 12}}>Submit</Button>
                            </Space>
                        </Form.Item>


                    </Form>
                </Modal>
            </div>
        </StompSessionProvider>
    );
}
